import { Injectable } from '@angular/core';
import { Invite } from '@models/Core/Invite';
import { Session } from '@models/Sessions/Session';

import { RequestService } from '../request.service';

@Injectable()
export class UserInviteService {
  api = {
    root: '/users/invite',
    session: '/session',
    single: '/single',
    apply: '/apply',
  };

  constructor(private client: RequestService) {}

  post(invite: Invite) {
    return this.client.post<Invite, any>({
      uri: this.api.root,
      body: invite,
      handlers: {
        success: () => void undefined,
        error: () => void 0,
      },
    });
  }

  session(session: Session) {
    return this.client.get<Invite[]>({
      uri: this.api.root + this.api.session + '/' + session._id,
      handlers: {
        success: () => void 0,
        error: () => void 0,
      },
    });
  }

  uninvite(session: Session, invite: Invite) {
    return this.client.delete({
      uri: this.api.root + '/' + session._id + '/' + invite._id,
      handlers: {
        success: () => void 0,
        error: () => void 0,
      },
    });
  }

  get<T = unknown>(token: string) {
    return this.client.get<T>({
      uri: this.api.root + this.api.single + '/' + token,
      handlers: {
        success: () => void 0,
        error: () => void 0,
      },
    });
  }
}
